import moment from "moment"

const isNullOrEmpty = val => val === undefined || val === null || val == ""

export const isDateNullOrDefault = date =>
  date === undefined ||
  date === null ||
  date == "" ||
  moment(date).isValid() == false ||
  moment(date) < moment("1970-01-01") 

export const hasFieldError = (fieldErrors, prop) =>
  fieldErrors.find(x => x == prop) != undefined

export default isNullOrEmpty
